import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import fetchCommissionUpdateRequestReviewAndDecisions from "@faire/web-api/api/brand-order-commission/commission-update-request-review-and-decisions/brandOrderToken/get";
import fetchAllCommissionUpdateRequests from "@faire/web-api/api/brand-order-commission/commission-update-requests/list/post";
import { IListCommissionUpdateRequestsRequest } from "@faire/web-api/indigofair/data/IListCommissionUpdateRequestsRequest";
import { WebApiError } from "@faire/web-api/WebApiError";
import { SubType } from "../responseTypes";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DEFAULT_SORT_BY, DEFAULT_SORT_ORDER } from "../types";
import { orderNumberToBrandOrderToken } from "../utils/orderNumberToBrandOrderToken";
export var handleCommissionUpdateRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, callback) {
    var _commissionUpdateRequ, brandToken, orderNumber, brandOrderToken, commissionUpdateRequestsResponse, hasBrandOrder, commissionUpdateRequestReviewAndDecisionResponse, decision, _error$httpStatusCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          brandToken = getBrandToken();
          if (brandToken) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", callback(_defineProperty(_defineProperty({
            ok: false,
            status: 403
          }, SubType.REQUEST_COMMISSION_UPDATE, undefined), "error", "Brand token not found")));
        case 4:
          orderNumber = args.params.orderNumber;
          brandOrderToken = orderNumberToBrandOrderToken(orderNumber);
          _context.next = 8;
          return fetchAllCommissionUpdateRequests(IListCommissionUpdateRequestsRequest.build({
            brand_token: brandToken,
            sort_by: DEFAULT_SORT_BY,
            sort_order: DEFAULT_SORT_ORDER,
            pagination_data: {
              page_number: DEFAULT_PAGE,
              page_size: DEFAULT_PAGE_SIZE
            }
          }));
        case 8:
          commissionUpdateRequestsResponse = _context.sent;
          hasBrandOrder = commissionUpdateRequestsResponse.requests.some(function (request) {
            return request.brand_order_token === brandOrderToken;
          });
          if (hasBrandOrder) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", callback(_defineProperty(_defineProperty({
            ok: true,
            status: 200
          }, SubType.REQUEST_COMMISSION_UPDATE, {
            data: {
              is_brand_order_in_request_table: false,
              decision: undefined
            }
          }), "error", "")));
        case 12:
          _context.next = 14;
          return fetchCommissionUpdateRequestReviewAndDecisions(brandOrderToken);
        case 14:
          commissionUpdateRequestReviewAndDecisionResponse = _context.sent;
          decision = (_commissionUpdateRequ = commissionUpdateRequestReviewAndDecisionResponse.commission_update_request_decisions[0]) === null || _commissionUpdateRequ === void 0 ? void 0 : _commissionUpdateRequ.decision;
          return _context.abrupt("return", callback(_defineProperty(_defineProperty({
            ok: true,
            status: 200
          }, SubType.REQUEST_COMMISSION_UPDATE, {
            data: {
              is_brand_order_in_request_table: true,
              decision: decision
            }
          }), "error", "")));
        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](0);
          if (!(_context.t0 instanceof WebApiError)) {
            _context.next = 23;
            break;
          }
          return _context.abrupt("return", callback({
            ok: false,
            status: (_error$httpStatusCode = _context.t0.httpStatusCode) !== null && _error$httpStatusCode !== void 0 ? _error$httpStatusCode : 500,
            error: _context.t0.message
          }));
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 19]]);
  }));
  return function handleCommissionUpdateRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();